import Axios, {AxiosError as AxiosErrorType} from 'axios'

// Define constants for environment variables with fallbacks
const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000/api';
const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:8000';
const isDev = process.env.NODE_ENV !== 'production';

// Determine the base URL for API requests
const getBaseUrl = () => {
  // When running in Docker, use host.docker.internal
  if (API_URL?.includes('host.docker.internal')) {
    return API_URL.replace('/api', '')
  }
  // Otherwise use localhost
  return 'http://localhost:8000'
}

// Create a separate instance for CSRF requests
const csrfInstance = Axios.create({
  baseURL: getBaseUrl(),
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
  }
})

const baseURL = API_URL;

if (!baseURL) {
  console.warn('⚠️ API URL is not set. Defaulting to http://localhost:8000/api')
}

const axios = Axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// Add token to requests if available
axios.interceptors.request.use(async (request) => {
  // if (isDev) {
  //   console.log('Starting Request:', {
  //     url: request.url,
  //     method: request.method,
  //     headers: request.headers,
  //     baseURL: request.baseURL,
  //   })
  // }

  // Attach Authorization token if available
  const token = typeof window !== 'undefined' ? localStorage.getItem('auth_token') : null
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`
  }

  // Attach CSRF token from cookie if available
  if (typeof document !== 'undefined') {
    const match = document.cookie.match(new RegExp('(^| )XSRF-TOKEN=([^;]+)'))
    if (match) {
      request.headers['X-XSRF-TOKEN'] = decodeURIComponent(match[2])
    }
  }

  return request
})

// Add response interceptor for consistent error handling
axios.interceptors.response.use(
  (response) => {
    // if (isDev) {
    //   console.log('Response received:', {
    //     status: response.status,
    //     headers: response.headers,
    //     data: response.data,
    //   })
    // }
    
    // Save token if it's a login response
    if (response.data?.token) {
      localStorage.setItem('auth_token', response.data.token)
    }

    return response
  },
  async (error) => {
    if (isDev) {
      console.error('Response error:', {
        status: error?.response?.status,
        data: error?.response?.data,
        headers: error?.response?.headers,
        message: error.message,
      })
    }

    if (!error.response) {
      return Promise.reject(new Error('Unable to connect to the server. Please check your connection.'))
    }

    // Handle 401 Unauthorized
    if (error.response.status === 401) {
      // Clear token and redirect to login if needed
      localStorage.removeItem('auth_token')
      if (typeof window !== 'undefined') {
        // You might want to trigger a logout action here
        console.log('User is unauthorized, clearing token')
      }
    }

    return Promise.reject(error)
  }
)

export type AxiosError<T = any> = AxiosErrorType<T>
export default axios
